import React from "react";

const TermsAndConditions = () => {
    return (
        <div className="account-pages my-5 pt-sm-5">
            <div className="container px-4 sm:px-6 md:px-8">
                <div className="row justify-content-center">
                    <div className="col-md-8 col-lg-6 col-xl-5">
                        <div className="card overflow-hidden">
                            {/* Ensure proper spacing */}
                            <div className="flex justify-center items-center min-h-screen bg-gray-100 p-6">
                                <div className="bg-white p-6 w-full max-w-2xl mx-auto rounded-lg shadow-lg">
                                    <h1 className="text-2xl font-bold text-center mb-4">
                                        Mercator Mobile App Terms and Conditions
                                    </h1>
                                    <p className="text-gray-600 text-sm text-center mb-4">
                                        <strong>Last Updated:</strong> 2025
                                    </p>
                                    <div className="px-4 sm:px-6">
                                        <p className="mb-4">
                                            Welcome to the Mercator Mobile App ("App"). These Terms and Conditions
                                            ("Terms") govern your use of the App, which is provided by Mercator
                                            ("Company," "we," "our," or "us"). By using the App, you agree to
                                            these Terms. If you do not agree, please do not use the App.
                                        </p>

                                        <h4 className="text-lg font-semibold mb-2">1. Purpose of the App</h4>
                                        <p className="mb-4">
                                            The Mercator Mobile App is a companion tool for managers and
                                            authorized users of the Mercator SaaS platform, designed to provide
                                            access to business reports, updates, account summaries, and shipment
                                            tracking. The App is not intended for general consumer use.
                                        </p>

                                        <h4 className="text-lg font-semibold mb-2">2. Eligibility</h4>
                                        <ul className="list-disc list-inside mb-4">
                                            <li>Be an authorized user of the Mercator SaaS platform.</li>
                                            <li>Have a valid account provided by your company or organization.</li>
                                            <li>Use the App in compliance with applicable laws and regulations.</li>
                                        </ul>

                                        <h4 className="text-lg font-semibold mb-2">3. User Accounts and Access</h4>
                                        <ul className="list-disc list-inside mb-4">
                                            <li>
                                                Your access to the App is linked to your Mercator SaaS platform
                                                credentials.
                                            </li>
                                            <li>
                                                You are responsible for maintaining the confidentiality of your
                                                login information.
                                            </li>
                                            <li>
                                                Unauthorized access, sharing of login credentials, or misuse of the
                                                App is strictly prohibited.
                                            </li>
                                        </ul>

                                        <h4 className="text-lg font-semibold mb-2">4. Data and Privacy</h4>
                                        <p className="mb-4">
                                            The App may collect and process data necessary for its functionality,
                                            including account details, shipment tracking, and reports. We adhere
                                            to strict privacy and data protection policies as outlined in our
                                            <strong> Privacy Policy</strong>.
                                        </p>

                                        <h4 className="text-lg font-semibold mb-2">5. Usage Restrictions</h4>
                                        <ul className="list-disc list-inside mb-4">
                                            <li>Use the App for any unlawful or unauthorized purposes.</li>
                                            <li>Modify, reverse-engineer, or attempt to gain unauthorized access.</li>
                                            <li>
                                                Transmit viruses, malware, or engage in any activity that disrupts
                                                App functionality.
                                            </li>
                                        </ul>

                                        <h4 className="text-lg font-semibold mb-2">6. Intellectual Property</h4>
                                        <p className="mb-4">
                                            All content within the App, including trademarks, reports, and
                                            software, is owned by Mercator or its licensors. Users may not copy,
                                            distribute, or modify any part of the App without prior written
                                            consent.
                                        </p>

                                        <h4 className="text-lg font-semibold mb-2">
                                            7. Disclaimers and Liability Limitations
                                        </h4>
                                        <ul className="list-disc list-inside mb-4">
                                            <li>The App is provided "as is" without warranties of any kind.</li>
                                            <li>We do not guarantee uninterrupted or error-free operation.</li>
                                            <li>
                                                To the extent permitted by law, we are not liable for any damages.
                                            </li>
                                        </ul>

                                        <h4 className="text-lg font-semibold mb-2">8. Termination of Access</h4>
                                        <p className="mb-4">
                                            We reserve the right to suspend or terminate your access to the App if
                                            you violate these Terms, misuse the App, or your authorization
                                            expires.
                                        </p>

                                        <h4 className="text-lg font-semibold mb-2">9. Modifications to the Terms</h4>
                                        <p className="mb-4">
                                            We may update these Terms from time to time. Continued use of the App
                                            after modifications constitutes acceptance of the updated Terms.
                                        </p>

                                        <h4 className="text-lg font-semibold mb-2">
                                            10. Governing Law and Dispute Resolution
                                        </h4>
                                        <p className="mb-4">
                                            These Terms are governed by the law. Any
                                            disputes shall be resolved through arbitration or legal proceedings.
                                        </p>

                                        <h4 className="text-lg font-semibold mb-2">11. Contact Information</h4>
                                        <p>
                                            For any questions regarding these Terms, contact us at
                                            <strong> support@mercatorapp.com</strong>.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default TermsAndConditions;

